import {
  BaseClass,
  type ILabelModel,
  ILabelModelParameter,
} from '@ardoq/yfiles';
/** An {@link ILabelModelParameter} that stores an {@link ILabelModel} passed to its constructor, and returns it when asked. */
class LabelModelParameter extends BaseClass(ILabelModelParameter) {
  #model: ILabelModel;
  constructor(model: ILabelModel) {
    super();
    this.#model = model;
  }
  override get model(): ILabelModel {
    return this.#model;
  }
  override clone(): this {
    return this;
  }
}
export { LabelModelParameter };
